import { useEffect, useState } from 'react';

import { useLocale } from 'state/intl';

interface IApolloResult {
  data?: any;
  loading: boolean;
  error?: any;
  refetch: Function;
}

type AppDataQueryInput = { variables: { appDataId: string }; skip: boolean };
type AppDataQuery = (input: AppDataQueryInput) => IApolloResult;

// WARNING:
// Do not use conditional logic around which queries get passed to this function.
// React Hooks depend on being called in the same order each time.
// Passing different queries as state changes (for example, when the user visits a new page)
// will cause unexpected behavior.
const useCoordinatedAppDataQueries = (queries: AppDataQuery[], appDataId: string) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { locale } = useLocale();
  const results = queries.map(query => query({ variables: { appDataId }, skip: !appDataId }));
  useEffect(() => {
    setLoading(results.some(result => result.loading));
    setError(results.some(result => result.error));
  }, [results]);
  useEffect(() => {
    results.forEach(result => result.refetch());
  }, [locale]); // eslint-disable-line react-hooks/exhaustive-deps
  return { loading, error };
};

export default useCoordinatedAppDataQueries;
